<script lang="ts" setup>
import type { ITranslationKey } from '@/objects/TranslationKey';
import { computed } from 'vue';
import IconComp from '@/components/IconComp.vue';

const props = defineProps<{
    modelValue: number | boolean | null;
    id: string;
    translationkey: ITranslationKey;
    intMode?: boolean;
    labelclass?: string;
    isButton?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const value = computed<boolean>({
    get() {
        if (props.intMode || false) {
            return props.modelValue == 1;
        } else {
            return props.modelValue as boolean;
        }
    },
    set(value) {
        if (props.intMode || false) {
            emit('update:modelValue', value ? 1 : 0);
        } else {
            emit('update:modelValue', value);
        }
    },
});
</script>
<template>
    <div :class="{ 'form-check': isButton !== true }">
        <template v-if="isButton == true">
            <input
                v-model="value"
                type="checkbox"
                class="btn-check"
                :id="id"
                autocomplete="off"
            />
            <label
                :class="'btn' + ' ' + labelclass"
                :for="id"
                ><IconComp :icon="value ? 'fa-check' : 'fa-square'" /><span v-html="$tm(translationkey.key ?? '', '', true)"></span
            ></label>
        </template>
        <template v-if="isButton !== true">
            <input
                v-model="value"
                :id="id"
                type="checkbox"
                class="form-check-input"
            />
            <label
                :class="'form-check-label' + ' ' + labelclass"
                :for="id"
                ><span v-html="$tm(translationkey.key ?? '', '', true)"></span
            ></label>
        </template>
    </div>
</template>
